import Swiper from 'swiper'
import 'swiper/css/bundle'
import {responsive} from '../../js/utils/breakpoints'
import elementIndex from '../utils/elementIndex'

export default class MobileTabMenu {
	constructor( element ) {
		this.element = element
		this.windowResizeHandler = this.windowResizeHandler.bind( this )
		this.addTitleCarousel = this.addTitleCarousel.bind( this )
		this.removeTitleCarousel = this.removeTitleCarousel.bind( this )
	}

	init() {
		this.titlesContainer = this.element.querySelector( '.mobile-tab-menu' )
		if ( ! this.titlesContainer ) return
		this.titlesWrapper = this.titlesContainer.querySelector( '.mobile-tab-menu--wrapper' )
		this.titles = Array.from( this.titlesContainer.querySelectorAll( '.mobile-tab-menu--tab-title' ) )
		if ( this.titles.length > 0 ) this.titles[ 0 ].classList.add( 'active' )
		this.windowResizeHandler()
	}

	windowResizeHandler() {
		if ( ! this.titlesContainer || ! this.titlesWrapper ) return
		if ( window.innerWidth < responsive.md ) {
			this.addTitleCarousel()
		} else {
			this.removeTitleCarousel()
		}
	}

	removeTitleCarousel() {
		if ( this.element.titlesSwiper ) this.element.titlesSwiper.destroy()
	}

	addTitleCarousel() {
		if ( this.element.titlesSwiper && this.element.titlesSwiper.destroyed != true ) return

		this.element.titlesSwiper = new Swiper( this.titlesContainer, {
			slidesPerView: 'auto',
			direction: 'horizontal',
			freeMode: true,
			shortSwipes: true,
			loop: false,
		} )
	}

	setActive( active ) {
		this.titles.forEach( title => {
			title.classList.remove( 'active' )
		} )
		active.classList.add( 'active' )
		const itemIndex = elementIndex( active )
		this.element.titlesSwiper && this.element.titlesSwiper.slideTo( itemIndex )
	}
}
